<template>
	<v-container>
		<!-- Alerts -->
		<v-alert type="success" v-if="success">
			You successfully {{ isAdd ? "added " : "updated " }} an event
		</v-alert>
		<v-alert type="error" v-if="failed"> Something Went Wrong </v-alert>
		<!-- Alerts End -->
		<!-- Form Container -->
		<v-layout row justify-center>
			<v-flex sm12 md10>
				<v-form ref="form" class="pa-12">
					<!-- Event/Class/KC selector -->
					<v-select
						:items="Events"
						return-object
						item-text="title"
						item-value="id"
						label="Select an Event or Class to Add"
						v-model="about.location"
						@input="(event) => getDocs(event)"
					/>
					<v-select
						outlined
						:items="docsList"
						return-object
						label="Select the Event-Class to Modify"
						v-model="identifier"
						@input="(identifier) => getDoc(identifier)"
						v-if="isUpdate"
					/>
					<!-- Title -->
					<label>
						{{ isAdd ? "Add " : "Update " }}{{ about.location.title }} Title:
					</label>
					<v-text-field outlined v-model="about.title"> </v-text-field>
					<!-- Description -->
					<label>
						{{ isAdd ? "Add " : "Update " }}
						{{ about.location.title }} Description:
					</label>
					<v-textarea outlined v-model="about.description"></v-textarea>
					<!-- Disable signup -->
					<v-radio-group v-model="about.signupDisabled" v-if="!isKidsCamp">
						<p>Disable online signup</p>
						<v-radio label="Yes" :value="true"></v-radio>
						<v-radio label="No" :value="false"></v-radio>
					</v-radio-group>
					<!-- Capacity -->
					<div v-if="about.location.id !== 'kids-camps'">
						<label>
							{{ isAdd ? "Add " : "Update "
							}}{{ about.location.title }} Capacity:
						</label>
						<v-text-field outlined v-model="about.capacity" />
					</div>
					<!--Renderes Date dynamically Start and end if kids camp-->
					<div>
						<v-menu
							ref="menu"
							v-model="menu"
							:close-on-content-click="false"
							:nudge-right="40"
							:return-value.sync="about.date"
							transition="scale-transition"
							offset-y
							min-width="290px"
						>
							<template v-slot:activator="{ on }">
								<v-text-field
									outlined
									v-model="about.date"
									label="Select Date"
									prepend-icon="event"
									readonly
									v-on="on"
								></v-text-field>
							</template>
							<v-date-picker v-model="about.date" no-title type="date">
								<!--can add scrollable-->
								<v-spacer></v-spacer>
								<v-btn color="brown lighten-1 white--text" @click="menu = false"
									>Cancel</v-btn
								>
								<v-btn
									color="brown lighten-1"
									@click="$refs.menu.save(about.date)"
									>OK</v-btn
								>
							</v-date-picker>
						</v-menu>
						<v-menu
							ref="menuEnd"
							v-model="menuEnd"
							:close-on-content-click="false"
							:nudge-right="40"
							:return-value.sync="about.endDate"
							transition="scale-transition"
							offset-y
							min-width="290px"
							v-if="isKidsCamp"
						>
							<template v-slot:activator="{ on }">
								<v-text-field
									outlined
									v-model="about.endDate"
									label="Select End Date"
									prepend-icon="event"
									readonly
									v-on="on"
								></v-text-field>
							</template>
							<v-date-picker v-model="about.endDate" no-title type="date">
								<!--can add scrollable-->
								<v-spacer></v-spacer>
								<v-btn
									color="brown lighten-1 white--text"
									@click="menuEnd = false"
									>Cancel</v-btn
								>
								<v-btn
									color="brown lighten-1"
									@click="$refs.menuEnd.save(about.endDate)"
									>OK</v-btn
								>
							</v-date-picker>
						</v-menu>
					</div>
					<!--Renderes time slots dynamically-->
					<div v-for="(slot, index) in slots" :key="index">
						<v-menu
							ref="menu1"
							v-model="slot.menu"
							:close-on-content-click="false"
							:nudge-right="40"
							:return-value.sync="slot.picker"
							transition="scale-transition"
							offset-y
							min-width="290px"
							v-if="!isKidsCamp"
						>
							<template v-slot:activator="{ on }">
								<v-text-field
									outlined
									v-model="slot.picker"
									:label="
										about.location.id === 'kids-camps'
											? `Select Event Start Time`
											: `Select Event Time ${index + 1}`
									"
									prepend-icon="access_time"
									readonly
									v-on="on"
								></v-text-field>
							</template>
							<v-time-picker color="brown" v-model="slot.picker">
								<v-btn
									text
									color="brown lighten-1 white--text"
									@click="slot.menu = false"
									>Cancel</v-btn
								>
								<v-btn
									text
									color="brown lighten-1"
									@click="$refs.menu1[index].save(slot.picker)"
									>OK</v-btn
								>
							</v-time-picker>
						</v-menu>
					</div>
					<!--Renderes time actions-->
					<v-layout row justify-center v-if="!isKidsCamp">
						<v-flex sm12 md6>
							<v-btn
								@click="slotActions('Add')"
								text
								outlined
								block
								class="mb-2"
								>Add time slots</v-btn
							>
						</v-flex>
						<v-flex sm12 md6>
							<v-btn
								@click="slotActions('Remove')"
								text
								outlined
								block
								class="mb-2"
								>Remove time slots</v-btn
							>
						</v-flex>
					</v-layout>
					<!--Renderes image uploader-->
					<v-file-input
						type="file"
						v-model="file"
						accept="image/*"
						lable="upload Image"
						prepend-icon="mdi-camera"
						v-if="$route.params.id === 'Add'"
					/>
					<!-- Add Event Button -->
					<v-btn
						text
						dark
						class="black"
						block
						v-on:click="postEvent()"
						:disabled="disable"
					>
						{{ isAdd ? "Add" : "Update" }}
						{{ about.location ? about.location.type : "Event/Class" }}</v-btn
					>
				</v-form>
			</v-flex>
		</v-layout>
	</v-container>
</template>
<script>
import fb from "@/fb";
import _ from "lodash";
import DateTime from "@/Models/DateTime";
import { Events } from "@/Models/Events";

export default {
	props: {},
	data() {
		return {
			defaultSlot: { menu: false, picker: "" },
			slots: [{ menu: false, picker: "" }],
			menu: false,
			menuEnd: false,
			selectedFile: null,
			success: false,
			failed: false,
			file: null,
			picture: null,
			Events: _.sortBy(Events, [
				(event) => {
					return event.title;
				},
			]),
			about: {
				signupDisabled: false,
				title: "",
				description: "",
				date: null,
				image: null,
				capacity: null,
				timestamp: null,
				timeSlots: [],
				location: { id: "", title: "", type: "", about: "", images: [] },
				ageGroup: null,
				endDate: null,
			},
			isYouth: false,
			disable: false,
			eventsref: fb.db.collection("Events"),
			isKidsCamp: false,
			isAdd: this.$route.params.id === "Add",
			isUpdate: this.$route.params.id === "Modify",
			docsList: [],
			identifier: "",
			eventID: "",
		};
	},
	watch: {
		"$route.params": function(to) {
			this.isAdd = to.id === "Add";
			this.isUpdate = to.id === "Modify";
		},
		"about.location": function(newAbout, oldAbout) {
			if (newAbout !== oldAbout) {
				this.isKidsCamp = newAbout.id === "kids-camps";
			}
		},
	},
	methods: {
		slotActions: async function(action) {
			if (action === "Add") {
				this.slots.push(this.defaultSlot);
			}

			if (action === "Remove") {
				if (this.slots.length > 1) {
					this.slots.pop();
				}
			}
		},

		generateDateStamp: async function() {
			return new DateTime(this.about.date, this.slots[0].picker);
		},

		async generateSlotsArray() {
			const timeSlots = [];
			_.forEach(this.slots, (slot) => {
				if (slot.picker) {
					timeSlots.push(slot.picker);
				}
			});

			return timeSlots;
		},

		async resetForm() {
			this.about = {
				title: "",
				description: "",
				date: null,
				image: null,
				capacity: null,
				timestamp: null,
				timeSlots: [],
				location: { id: "", title: "", type: "" },
				ageGroup: null,
				endDate: null,
			};
			this.file = null;
			this.defaultSlot = { menu: false, picker: "" };
			this.slots = [{ menu: false, picker: "" }];
		},

		async postEvent() {
			this.disable = true;

			this.about.timeSlots = await this.generateSlotsArray();
			this.about.capacity = Number(this.about.capacity);
			if (this.about.location.id === "kids-camps") {
				delete this.about.signupDisabled;
				this.about["time"] = "08:00";
				this.about["endTime"] = "16:30";
				this.about["ageGroup"] = "9-14";
				this.about["type"] = "Summer Camp";
			}
			if (this.about.location.id !== "kids-camps") {
				delete this.about.endDate;
				delete this.about.ageGroup;
			}
			delete this.about.location.about;
			delete this.about.location.images;

			if (this.isAdd) {
				//add in computed properties for add
				const dateTime = await this.generateDateStamp();
				const photoRef = await fb.storage.ref(this.file.name).put(this.file);
				const photoURL = await photoRef.ref.getDownloadURL();
				this.about.timestamp = dateTime.timestamp;
				this.about.image = photoURL;
			}

			try {
				this.isUpdate
					? await this.eventsref.doc(this.eventID).set(this.about)
					: await this.eventsref.add(this.about);

				this.success = true;
				this.disable = false;
				this.resetForm();
			} catch (err) {
				console.log(err);
				this.failed = true;
				this.disable = false;
			}
		},

		async getDocs({ id }) {
			const rawEvents = await fb.db
				.collection("Events")
				.where("location.id", "==", id)
				.get();

			this.docsList = [];

			for (const event of rawEvents.docs) {
				const { id } = event;
				const { title, date, timeSlots } = event.data();
				this.docsList.push(`${title}//${date}//${timeSlots[0]}//${id}`);
			}
		},

		async getDoc(event) {
			this.eventID = event.split("//")[3];

			if (this.$route.params.id === "Modify") {
				await this.resetForm();

				this.docsList = [];
				const rawEvent = await fb.db
					.collection("Events")
					.doc(this.eventID)
					.get();

				const {
					capacity,
					title,
					date,
					timeSlots,
					location,
					signupDisabled,
					timestamp,
					ageGroup,
					endDate,
					description,
					image,
					type,
				} = rawEvent.data();
				this.about = {
					signupDisabled,
					title,
					description,
					date,
					image,
					capacity,
					timestamp,
					timeSlots,
					location,
					ageGroup,
					endDate,
				};
				this.isYouth = type === "Youth Camp" ? true : false;
				this.identifier = event;
				this.slots = _.map(timeSlots, (slot) => {
					return { menu: false, picker: slot };
				});
			}
		},
	},
};
</script>
